import React from "react";
import { SemanticAd } from "src/types/SemanticAd";
import { Ad } from "../../components/Ad";

type ResultItemProps = {
	ad: SemanticAd;
	onInscreen?: (ad: SemanticAd, position: number) => void;
	onClick?: (ad: SemanticAd, position: number) => void;
	position: number;
	isMobile: boolean;
	currency: string;
};

export function ResultItem(props: ResultItemProps) {
	const { ad, onInscreen, onClick, position, isMobile, currency } = props;

	const handleAdClick = React.useCallback(() => {
		onClick?.(ad, position);
	}, [ad, onClick, position]);

	const handleAdInscreen = React.useCallback(() => {
		onInscreen?.(ad, position);
	}, [ad, position, onInscreen]);

	const adProps = {
		onClick: handleAdClick,
		onFirstInscreen: handleAdInscreen,
		isMobile,
		currency,
	};

	return <Ad ad={ad} {...adProps} />;
}
